"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledMonth = void 0;
var _PlannerMonth = _interopRequireWildcard(require("@oberoninternal/travelbase-ds/components/calendar/PlannerMonth"));
var _react = require("react");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import propsAreEqual from '@oberoninternal/travelbase-ds/utils/propsAreEqual';
// import { BoxProps } from '@rebass/grid';

// import { areSamePeriods } from '../../../utils/planner';

const StyledMonth = exports.StyledMonth = (0, _styledComponents.default)(_PlannerMonth.default).withConfig({
  displayName: "Month__StyledMonth",
  componentId: "sc-1sl61yf-0"
})(["width:100%;", ":first-of-type{position:sticky;background:white;top:2rem;z-index:10;}> div:first-of-type{position:sticky;background:white;top:0;z-index:11;margin-bottom:0;padding:0;}@media screen and (min-width:", "){width:calc(50% - 0.8rem);height:100%;padding:8px 0;}"], _PlannerMonth.PlannerWeek, ({
  theme
}) => theme.mediaQueries.s);
const Month = /*#__PURE__*/(0, _react.memo)(StyledMonth
// TODO: fix this
// propsAreEqual<Omit<PlannerMonthProps, keyof BoxProps>>({
//     date: (prev: any, next: any) => +prev === +next,
//     period: areSamePeriods,
//     onDayClick: 'skip',
//     onDayMouseEnter: 'skip',
//     onDayMouseLeave: 'skip',
// })
);
var _default = exports.default = Month;